import React, { useState,Fragment } from 'react';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './OrderUpdatedSuccessfullyModal.css';
import orderUpdatedSuccessfullyModal from '../../assets/images/orderUpdatedSuccessfullyModal.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const OrderUpdatedSuccessfullyModal= ({ open, handleClose }) => {
  // const [open, setOpen] = useState(true);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };
  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
    <Fragment >
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Order Updated Successfully Modal
      </Button> */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth="md" // Adjust the maxWidth as needed
        maxHeight="md" // Adjust the maxHeight as needed
        
      >
        <DialogTitle sx={{ m: 0, p: "0px 0px" }} id="customized-dialog-title">
          {/* Modal title */}
              <div className='orderUpdatedSuccessfullyModalImagediv'>  
                <img 
                  className='orderUpdatedSuccessfullyModalImage'
                  src={orderUpdatedSuccessfullyModal}
                  alt='modal'
                />
                <h4 
                  className='headingForOrderUpdateSuccessfullyModal'
                > Purchase Order Updated Successfully </h4>
              </div>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor:"white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
      </BootstrapDialog>
    </Fragment>
  );
}

export default  OrderUpdatedSuccessfullyModal